import { SetStateAction, WritableAtom } from 'jotai';
import { initHints } from './utils/hintsFactory';

const STORAGE_VERSION = 'v1';
const STORAGE_NAME = `sim-hints`;

export type CustomFieldHints = Record<string, string[]>;

type SimInventoryHints = {
  accounts: string[];
  productCodes: string[];
  tags: string[];
  connectionId: string[];
  orderNumber: string[];
  mobileNetworkOperator: string[];
  customFields: CustomFieldHints;
};

const INITIAL_VALUES: SimInventoryHints = {
  accounts: [],
  productCodes: [],
  tags: [],
  connectionId: [],
  orderNumber: [],
  mobileNetworkOperator: [],
  customFields: {},
};
//#TODO: add types

const { storageAtom, syncAtom, updateAllAtom, gettersAndRemovers } = initHints<SimInventoryHints>({
  storageName: STORAGE_NAME,
  storageVersion: STORAGE_VERSION,
  initialValues: INITIAL_VALUES,
});

const {
  accounts,
  productCodes,
  tags,
  connectionId,
  orderNumber,
  mobileNetworkOperator,
  customFields,
} = gettersAndRemovers;

export const simHintsAtomWithStorage = storageAtom;
export const syncHintsAtom = syncAtom;
export const updateHintsAtom = updateAllAtom;
export const connectionIdHintsAtom = connectionId;
export const orderNumberHintsAtom = orderNumber;
export const simTagsHintsAtom = tags;
export const simAccountsHintsAtom = accounts as WritableAtom<string[], [SetStateAction<any>], void>;
export const productCodesHintsAtom = productCodes as WritableAtom<
  string[],
  [SetStateAction<any>],
  void
>;
export const mnoHintsAtom = mobileNetworkOperator;
export const customFieldsHintsAtom = customFields;
